export default function handleNavigation() {
    const navOpenClass = 'nav-active';
    const subNavOpenClass = 'sub-nav-active';
    const DESKTOP_BREAKPOINT = 1024;
    const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

    const syncSubNavState = () => {
        const hasActiveSubnav = $('.js-nav-item.sub-nav-active').length > 0;
        $('body').toggleClass(subNavOpenClass, hasActiveSubnav);
    };

    $('body')
        .on('click', '.js-toggle-navigation', function () {
            const $body = $('body');
            const isOpening = !$body.hasClass(navOpenClass);

            $body.toggleClass(navOpenClass);

            if (!isOpening) {
                $('.js-nav-item.sub-nav-active').removeClass('sub-nav-active');
                $body.removeClass(subNavOpenClass);
            }

            $('.js-toggle-navigation').attr(
                'aria-expanded',
                $body.hasClass(navOpenClass) ? 'true' : 'false'
            );

            return false;
        })
        .on('click', '.js-show-dropdown', function () {
            if (isDesktop()) {
                return;
            }

            $(this).closest('.js-nav-item').addClass('sub-nav-active');
            syncSubNavState();

            return false;
        })
        .on('click', '.js-hide-dropdown', function () {
            if (isDesktop()) {
                return;
            }

            $(this).closest('.js-nav-item.sub-nav-active').removeClass('sub-nav-active');
            syncSubNavState();

            return false;
        });

    $(window).on('resize', () => {
        if (isDesktop()) {
            $('body').removeClass(`${navOpenClass} ${subNavOpenClass}`);
            $('.js-nav-item.sub-nav-active').removeClass('sub-nav-active');
            $('.js-toggle-navigation').attr('aria-expanded', 'false');
        }
    });
}